module.exports = __webpack_public_path__ + "static/img/Tech_04.e69ead37.png";